import { mapState } from "vuex";
export const LoginAndFreeTrialNC = {
	methods: {
		postLoginNC(response) {
			const x_access_token = JSON.parse(response.data).access;
			const x_refresh_token = JSON.parse(response.data).refresh;
			// console.log("access", x_access_token, "refresh", x_refresh_token);
			if (response.status == 200) {
				this.dialogVisible = false;
				window.localStorage.setItem(
					"x-access-token",
					JSON.stringify(x_access_token)
				);
				window.localStorage.setItem(
					"x-refresh-token",
					JSON.stringify(x_refresh_token)
				);
				this.isDataUpdated();
				this.getLoginUserDetails();
			}
			// window.location.reload();
			this.$notify.success({
				title: "Success",
				message: "Success",
				type: "success"
			});

			// Clear local storage store info
			if(localStorage.getItem('store_id')) {
				localStorage.setItem('store_id', '');
			}
		},
		getLoginInfo(response) {
			try {
				let user_info = JSON.parse(response.data);
				this.$store.commit("getUserDetails", user_info);
				localStorage.setItem("user_id", user_info.id); //stored user name for show sub dropdown in side bar
				localStorage.setItem("user_email", user_info.email); //stored user name for show sub dropdown in side bar
				localStorage.setItem("user_access_level", user_info.access_level); //stored user name for show sub dropdown in side bar

				localStorage.setItem("access_region", user_info.access_region[0]); //stored user name for show sub dropdown in side bar
				localStorage.setItem("access_subregion", user_info.access_subregion[0]); //stored user name for show sub dropdown in side bar
				localStorage.setItem("access_outlet", user_info.access_outlet); //stored user name for show sub dropdown in side bar
				if (!this.idDataUpdatedStatus) {
					// if(user_info.email == "bkpoc@nymbleup.com") {
					// 	this.$router.push({ name: "SingleStoreData" });
					// }else {
					// 	this.$router.push("/admin/sales-dd/location");
					// }
					// use for starbucks user
					if(user_info.email.toLowerCase().indexOf('@theobroma.in') !== -1 || user_info.email == 'tushar.shinde@wellnessforever.in' || user_info.email == 'gokuldas.gawade@wellnessforever.in' || user_info.email == 'safiahmad.khan@wellnessforever.in' || user_info.email == 'ratnesh.maurya@wellnessforever.in' || user_info.email == 'amar.soni@wellnessforever.in' || this.companyData.name == 'Easy Aspataal' || user_info.email == 'ajitagawade1994@gmail.com' || user_info.email == 'prateek@easyaspataal.com'){
						this.$router.push({ name: "Tasks" }).catch(()=>{});
					}else{
						if(user_info.access_level == "vendor") {
							this.$router.push({ name: "SentOrder" }).catch(()=>{});
						}else if(user_info.access_level == "employee")  {
							this.$router.push({ name: "SchedulePlanner" }).catch(()=>{});
						}else if(user_info.access_level == 'outlet')  {
							this.$router.push({ name: "SchedulePlanner" }).catch(()=>{});
						} else {
							// this.$router.push({ name: "WrokForceDashboard" });
							this.$router.push({ name: "SchedulePlanner" }).catch(()=>{});
						}
					}
				} else {
					this.$router.push("/admin/sales-dd/location").catch(()=>{});
				}
			} catch(error) {
				console.error(error);
			}
		},
		userStatus(response) {
			if (response.status == 200) {
				if (
					JSON.parse(response.data).message == "This user is not registered"
				) {
					this.goToUserInformation();
				} else {
					this.$notify.error({
						title: "Fail",
						message: JSON.parse(response.data).message
					});
				}
			}
		}
	},
	computed: {
		...mapState("CommonStore", ["companyData"]),
	}
};
